export const DEFAULT_SIMILAR_RESIDENTS_CONTROL = {
    items: [],
    openDemographics: false,
    setOpenDemographics: () => { },
    disableToggle: false,
    modal: null,
    isFetchingLinkedResident: false,
    isEditing: false,
    linkedResident: null,
    organizationId: "",
    isReadOnly: true,
};
